// robo-AMP35：页脚后 Tab — Firework → UC → 抽奖入口 → floating-sidebar(Subscribe/Refer/Chat/BTT)
// 统一锚点 #robo-fixed-widgets-tab-start；搬 Firework 真实 host（含 SDK 挂到 body 的 fw-player）
(function () {
  if (window.__roboFixedWidgetsTabInit) return;
  window.__roboFixedWidgetsTabInit = true;

  var ROBO_FIXED_WIDGET_IDS = {
    cmpLoader: "usercentrics-cmp",
    tabStart: "robo-fixed-widgets-tab-start",
    suspended: "suspendedNavigation",
  };

  function isThemeLayoutNode(el) {
    if (!el || el.nodeType !== 1) return false;
    var id = el.getAttribute("id") || "";
    if (id === "MainContent" || id.indexOf("shopify-section") === 0) return true;
    if (el.classList) {
      if (el.classList.contains("site-wrapper")) return true;
      if (el.classList.contains("ro-floating-sidebar")) return true;
      if (el.classList.contains("drawContentSectionFJ")) return true;
      if (el.classList.contains("ro_bootsrap-footer")) return true;
      if (el.classList.contains("grid")) return true;
    }
    var tag = el.tagName.toLowerCase();
    return tag === "header" || tag === "footer" || tag === "main" || tag === "nav";
  }

  function isUsercentricsUiNode(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isThemeLayoutNode(el)) return false;
    if (el.classList && el.classList.contains("firework-container")) return false;

    var id = el.getAttribute("id") || "";
    if (id === ROBO_FIXED_WIDGET_IDS.cmpLoader) return false;
    if (id === ROBO_FIXED_WIDGET_IDS.tabStart) return false;
    if (id === ROBO_FIXED_WIDGET_IDS.suspended) return false;

    if (id.indexOf("usercentrics") === 0 || id.indexOf("uc-") === 0) return true;
    if (el.getAttribute("data-testid") === "uc-app-container") return true;

    if (el.children && el.children.length > 30) return false;
    if (
      el.querySelector(
        '[data-testid="uc-app-container"], [id^="usercentrics-"]:not(#usercentrics-cmp), [id^="uc-"]'
      )
    ) {
      return true;
    }
    return false;
  }

  function addUniqueNode(list, el) {
    if (!el || list.indexOf(el) !== -1) return;
    list.push(el);
  }

  function getFireworkTabHosts() {
    var hosts = [];
    Array.prototype.forEach.call(document.querySelectorAll(".firework-container"), function (el) {
      addUniqueNode(hosts, el);
    });

    Array.prototype.forEach.call(document.querySelectorAll("fw-player"), function (player) {
      if (player.closest(".firework-container")) return;

      if (player.parentNode === document.body) {
        addUniqueNode(hosts, player);
        return;
      }

      var parent = player.parentNode;
      if (
        parent &&
        parent.parentNode === document.body &&
        !isThemeLayoutNode(parent) &&
        !isUsercentricsUiNode(parent)
      ) {
        addUniqueNode(hosts, parent);
        return;
      }

      if (!player.closest("#MainContent, .site-wrapper, header, footer, .ro_bootsrap-footer")) {
        addUniqueNode(hosts, player);
      }
    });

    return hosts;
  }

  function getUsercentricsUiNodes() {
    var tabStart = document.getElementById(ROBO_FIXED_WIDGET_IDS.tabStart);
    var nodes = [];
    if (!document.body) return nodes;

    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === tabStart) return;
      if (el.classList && el.classList.contains("firework-container")) return;
      if (el.tagName && el.tagName.toLowerCase() === "fw-player") return;
      if (isUsercentricsUiNode(el)) addUniqueNode(nodes, el);
    });
    return nodes;
  }

  function groupIsImmediatelyBefore(anchor, nodes) {
    if (!anchor || !nodes.length) return true;
    var el = nodes[0];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] !== el) return false;
      el = el.nextElementSibling;
    }
    return el === anchor;
  }

  function placeGroupBefore(anchor, nodes) {
    if (!anchor || !anchor.parentNode || !nodes.length) return;
    var filtered = nodes.filter(function (el) {
      return el && el !== anchor && !el.contains(anchor);
    });
    if (!filtered.length) return;
    if (groupIsImmediatelyBefore(anchor, filtered)) return;

    var parent = anchor.parentNode;
    for (var i = 0; i < filtered.length; i++) {
      parent.insertBefore(filtered[i], anchor);
    }
  }

  function collapseContainedNodes(nodes) {
    var out = [];
    nodes.forEach(function (el) {
      if (!el || out.indexOf(el) !== -1) return;
      if (
        out.some(function (n) {
          return n.contains(el);
        })
      ) {
        return;
      }
      out = out.filter(function (n) {
        return !el.contains(n);
      });
      out.push(el);
    });
    return out;
  }

  function applyFixedWidgetsFocusOrder() {
    var tabStart = document.getElementById(ROBO_FIXED_WIDGET_IDS.tabStart);
    if (!tabStart || !tabStart.parentNode) return;

    var parent = tabStart.parentNode;
    var beforeNodes = collapseContainedNodes(
      getFireworkTabHosts().concat(getUsercentricsUiNodes())
    );
    placeGroupBefore(tabStart, beforeNodes);

    var sidebar = document.querySelector(".ro-floating-sidebar");
    var lotteryBtn = document.querySelector(".lotterynarrowing");
    var lotteryHost = lotteryBtn
      ? lotteryBtn.closest(".drawContentSectionFJ") || lotteryBtn
      : null;
    var afterNodes = [];
    if (lotteryHost) afterNodes.push(lotteryHost);
    if (sidebar) {
      afterNodes.push(sidebar);
    } else {
      [
        document.getElementById(ROBO_FIXED_WIDGET_IDS.suspended),
        document.querySelector(".embeddedMessagingConversationButtonWrapper"),
        document.querySelector(".as-btt-btn"),
      ].forEach(function (el) {
        if (el) afterNodes.push(el);
      });
    }

    if (afterNodes.length === 0) return;

    var alreadyOrdered =
      tabStart.nextElementSibling === afterNodes[0] &&
      afterNodes.every(function (el, i) {
        return i === afterNodes.length - 1 || el.nextElementSibling === afterNodes[i + 1];
      });
    if (alreadyOrdered) return;

    var anchor = tabStart;
    afterNodes.forEach(function (el) {
      if (anchor.nextElementSibling !== el) {
        parent.insertBefore(el, anchor.nextElementSibling);
      }
      anchor = el;
    });
  }

  var roboTabOrderTimer = null;
  var roboTabOrderObserver = null;

  function connectRoboTabOrderObserver() {
    if (!document.body) return;
    if (!roboTabOrderObserver) {
      roboTabOrderObserver = new MutationObserver(scheduleFixedWidgetsFocusOrder);
    }
    roboTabOrderObserver.observe(document.body, { childList: true, subtree: false });
  }

  function runFixedWidgetsFocusOrder() {
    roboTabOrderTimer = null;
    if (roboTabOrderObserver) roboTabOrderObserver.disconnect();
    try {
      applyFixedWidgetsFocusOrder();
    } finally {
      connectRoboTabOrderObserver();
    }
  }

  function scheduleFixedWidgetsFocusOrder() {
    if (roboTabOrderTimer) clearTimeout(roboTabOrderTimer);
    roboTabOrderTimer = setTimeout(runFixedWidgetsFocusOrder, 50);
  }

  window.scheduleFixedWidgetsFocusOrder = scheduleFixedWidgetsFocusOrder;

  window.addEventListener("UC_UI_INITIALIZED", scheduleFixedWidgetsFocusOrder);
  window.addEventListener("UC_CONSENT", scheduleFixedWidgetsFocusOrder);
  window.addEventListener("onEmbeddedMessagingReady", scheduleFixedWidgetsFocusOrder);

  connectRoboTabOrderObserver();
  scheduleFixedWidgetsFocusOrder();
})();
